import Avatar from "../Avatar";
import IMG from "../../constants/image";
import { Link, useLocation } from "react-router-dom";
import { LOCAL_STORAGE_KEY, PATH } from "../../constants";
import { setCookie } from "../../utils";
import cn from "classnames";
import merchantStore from "../../store/merchantStore";
import { useEffect, useState } from "react";
import Button from "../Common/Button";
import popupStore from "../../store/popupStore";
import { ENV } from "../../network/config";
import { text } from "../../constants/text";

const data = [
    {
        id: 1,
        title: 'Đổi mật khẩu',
        icon: IMG.icon.setup,
        to: PATH.CHANGE_PASSWORD
    },
    {
        id: 2,
        title: 'Thông tin cửa hàng',
        icon: IMG.icon.clipboardList,
        to: PATH.STORE_INFO
    },
    {
        id: 3,
        title: 'Sổ địa chỉ',
        icon: IMG.icon.location,
        to: PATH.ADDRESS
    },
    {
        id: 4,
        title: text.shippingConfig,
        icon: IMG.icon.truckBlack,
        to: PATH.SHIPPING_CONFIG
    },
    {
        id: 5,
        title: 'Chia sẻ',
        icon: IMG.icon.share,
        to: PATH.SHARE
    },
    {
        id: 6,
        title: 'Tin tức nông nghiệp',
        icon: IMG.icon.newspaper,
        to: ENV.FUNONG_DOMAIN + '/tin-tuc',
        external: true
    }
]

const NabarAccount = () => {

    const { merchantProfile } = merchantStore() || {};
    const { setPopup } = popupStore() || {};

    const [activeNav, setActiveNav] = useState();

    const location = useLocation();
    const { pathname } = location || {};

    const { avatar_url, description, owner_name, phone_number, merchant_name } = merchantProfile || {}

    useEffect(() => {

        const activeMenu = data.find((column) => {
            return (pathname).includes(column.to);
        })

        activeMenu && setActiveNav(activeMenu);

    }, [pathname])

    const handleLogout = () => {
        setPopup({
            isOpen: true,
            data: {
                title: 'Bạn muốn đăng xuất khỏi trang bán hàng?',
                image: IMG.popupUpdateStatus,
                accept: {
                    label: 'Quay lại',
                    action: () => setPopup({})
                },
                cancel: {
                    label: 'Đồng ý',
                    action: () => {
                        window.localStorage.removeItem(LOCAL_STORAGE_KEY.TOKEN)
                        setCookie('token-share', 'logout', 1)
                        window.location.href = PATH.LOGIN
                    }
                }
            }
        })
    }

    return (
        <div className='flex flex-col items-center px-5'>
            <div className='-mb-10 mx-auto text-center z-10'>
                <Avatar image={avatar_url} description={description} />
            </div>
            <div className='relative bg-[#F8C5181A] rounded-xl px-8 pt-12 pb-2.5 text-center'>
                <Link className='cursor-pointer' to={PATH.STORE_INFO + '?editing=true'}>
                    <div className='absolute right-4 top-3 flex items-center space-x-1 text-sm'>
                        <img className='w-5' src={IMG.icon.pencil} alt='pencil' />
                        <div>{text.edit}</div>
                    </div>
                </Link>
                <p className='font-bold'>{merchant_name || owner_name || phone_number || ''}</p>
                <p className='text-sm'>
                    {description || 'Mô tả ngắn về cửa hàng'}
                </p>
            </div>


            <div className='flex flex-col gap-2.5 w-full mt-5 bg-white px-[15px] py-[30px] rounded-xl'>
                {(data || []).map(item => {
                    if (item.disabled) {
                        return (
                            <div
                                key={item.to}
                                className={cn('flex justify-between items-center p-2.5 rounded-xl', item.disabled ? 'opacity-30' : 'hover:bg-[#F8C518]', activeNav?.id === item.id && 'bg-[#F8C518]')}>
                                <div className='flex justify-between items-center gap-2.5'>
                                    <img className='w-6 h-6' src={item.icon} alt="icon" />
                                    <p className='text-sm'>{item.title}</p>
                                </div>
                                <img className='items-end transform' src={IMG.icon.chevronRight} alt="arrowDown" />
                            </div>
                        )
                    }
                    return (
                        <Link className='cursor-pointer' to={item.to} key={item.to} target={item?.external && '_blank'}>
                            <div
                                className={cn('flex justify-between items-center p-2.5 rounded-xl', item.disabled ? 'opacity-30' : 'hover:bg-[#F8C518]', activeNav?.id === item.id && 'bg-[#F8C518]')}>
                                <div className='flex justify-between items-center gap-2.5'>
                                    <img className='w-6 h-6' src={item.icon} alt="icon" />
                                    <p className='text-sm'>{item.title}</p>
                                </div>
                                <img className='items-end transform' src={IMG.icon.chevronRight} alt="arrowDown" />
                            </div>
                        </Link>
                    )
                })}
            </div>
            <Button className='bg-white gap-3 text-[15px] hover:bg-[#F8C518] w-full md:w-[300px] h-[50px] mt-[15px]'
                onClick={handleLogout}>
                <img src={IMG.icon.logout} alt="" />
                Đăng xuất
            </Button>
            <p className='text-center text-[11px] text-[#9E9E9E] mt-[50px] mb-5 bg-[#EDEDED]'>CÔNG TY CP THƯƠNG MẠI ĐIỆN
                TỬ VẬN THÔNG 102 Trần Hưng Đạo, P. Phạm Ngũ Lão, Quận 1, TP.HCM</p>
        </div>
    )
}

export default NabarAccount;
